import { getLeafFolderIndex } from './getLeafFolderIndex';
import SimpleUri from '@ms/odsp-utilities/lib/uri/SimpleUri';

/**
 * @internal
 */
export function getCurrentRootFolder(listFullUrl: string, rootFolder?: string): string | undefined {
  let currentRootFolder = undefined;
  if (rootFolder) {
    const leafFolderIndex = getLeafFolderIndex(rootFolder, listFullUrl);
    const listUrl = new SimpleUri(listFullUrl).path; // get server relative url.
    if (leafFolderIndex > -1) {
      currentRootFolder = rootFolder.substring(0, leafFolderIndex);
      if (currentRootFolder === listUrl) {
        currentRootFolder = '';
      }
    }
  }
  return currentRootFolder;
}
